import common_en from "./en/common.json"
import common_it from "./it/common.json"
import common_fr from "./fr/common.json"

const languages = {
    "en-EN": {
        common: common_en,
    },
    "it-IT": {
        common: common_it,
    },
    "fr-FR": {
        common: common_fr,
    },
}

export default languages
